module.exports = __webpack_public_path__ + "static/media/icon-double-clap.824df034.svg";